<template>
  <section class='section container forgot-password'>
    <div class='box form-container'>

      <form @submit.prevent="submit" v-if="!submitted">
        <b-field label="Email" custom-class="content">
          <b-input type="email" v-model="email" />
        </b-field>
        <div class="submit-container">
          <button class="button is-primary submit" type="submit">
            Submit
          </button>
        </div>
      </form>
      <div v-else>
        <p>Check your email for your login link.</p>
        <p><b>Please check your spam folder as well!</b></p>
        <p>Click on this link, and set a new password.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      submitted: false,
      email: '',
    };
  },
  methods: {
    async submit() {
      try {
        await this.$http.post('/users/forgot_password/', { email: this.email });
      } catch (e) {
        // do nothing
      }
      this.submitted = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  display: flex;
  justify-content: center;
}
.submit-container {
  display: flex;
  justify-content: flex-end;
}
.form-container {
  max-width: 480px;
}
</style>
